import { Link, useLocation } from "react-router-dom";


const YEARS = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2017, 2016];

const YICUNav = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div style={{
      display: "flex", flexWrap: "wrap", alignItems: "center", gap: ".5rem",
      padding: "1rem 0 1.5rem",
      borderBottom: "1.5px solid var(--pk-100)", marginBottom: "0",
    }}>
      <span style={{
        fontSize: ".72rem", fontWeight: 700, letterSpacing: ".14em",
        textTransform: "uppercase", color: "var(--muted)", flexShrink: 0, marginRight: ".25rem",
      }}>
        Flashback:
      </span>
      {YEARS.map(year => {
        const href = year === 2027 ? "/yicu" : `/yicu${year}`;
        const isActive = currentPath === href || currentPath === `/yicu/${year}`;
        return (
          <Link key={year} to={href} style={{
            display: "inline-block", fontFamily: "var(--ff-body)", fontSize: ".75rem",
            fontWeight: 700, padding: ".32em .9em", borderRadius: "100px", textDecoration: "none",
            transition: "background .15s, color .15s, transform .15s",
            background: isActive ? "var(--pk-500)" : "var(--pk-100)",
            color: isActive ? "var(--white)" : "var(--pk-700)",
            border: `1.5px solid ${isActive ? "var(--pk-500)" : "var(--pk-200)"}`,
            transform: isActive ? "translateY(-1px)" : "none",
            boxShadow: isActive ? "0 2px 8px rgba(219,39,119,.25)" : "none",
          }}
            onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = "var(--pk-200)"; e.currentTarget.style.transform = "translateY(-1px)"; } }}
            onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = "var(--pk-100)"; e.currentTarget.style.transform = "none"; } }}
          >
            {year}
          </Link>
        );
      })}
    </div>
  );
};

export default YICUNav;